import { hFetch } from './hFetch';

export const create = async (id: number, name: string) => {
  return await hFetch({
    url: `/api/task_checklists/${id}/task_checklist_clones`,
    method: 'POST',
    payload: { task_checklist: { name } },
  });
};
